// 목록 표 정렬 머리 공용 — 글자 굵기·커서·키보드 조작을 한 벌로 맞춘다.
// active: 현재 정렬 열인지, dir: 'asc' | 'desc'.
import React from 'react';
import { Translate as t } from '../../config/Translate';

const SortableHeader = ({ label, active, dir, onToggle }) => (
    <span
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={onToggle}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(); } }}
    >
        {t(label)}{active ? (dir === 'desc' ? ' ▼' : ' ▲') : ''}
    </span>
);

export default SortableHeader;
